import { render, staticRenderFns } from "./MediaViewer.vue?vue&type=template&id=24683ff2&scoped=true"
import script from "./MediaViewer.vue?vue&type=script&lang=js"
export * from "./MediaViewer.vue?vue&type=script&lang=js"
import style0 from "./MediaViewer.vue?vue&type=style&index=0&id=24683ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24683ff2",
  null
  
)

export default component.exports